"use strict";
import Choices from 'choices.js';
import { tns } from "tiny-slider/src/tiny-slider";
import ScrollWatcher from "scroll-watcher";
import BigPicture from 'bigpicture'
import axios from 'axios';

// fonts.com Tracking code
var MTIProjectId='80d9f718-1f0f-4783-9831-4b51496465f1';

eval(function(p,a,c,k,e,r){e=function(c){return c.toString(a)};if(!''.replace(/^/,String)){while(c--)r[e(c)]=k[c]||e(c);k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('4 7=g.b;4 2=3.p(\'r\');2.9=\'a/5\';2.c=\'d\';2.e=(\'6:\'==3.u.h?\'6:\':\'i:\')+\'//j.k.l/t/1.5?m=n&o=\'+7;(3.8(\'q\')[0]||3.8(\'s\')[0]).f(2);',31,31,'||mtiTracking|document|var|css|https|projectId|getElementsByTagName|type|text|MTIProjectId|rel|stylesheet|href|appendChild|window|protocol|http|fast|fonts|net|apiType|css|projectid|createElement|head|link|body||location'.split('|'),0,{}));

//Mobile menu toggle
const button = document.querySelector('[data-behaviour="mobile-menu-toggle"]');

if(button) {
    button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.toggle('body--show-mobile-menu');
    });
}

//Selectbox
const linkboxes = document.querySelectorAll('[data-behaviour="selectbox-links"]');

const choices = [...linkboxes].map(node => {
    node.addEventListener('change', (e) => {
       document.location.href = e.target.value;
    });
    return new Choices(node);
});

//Slider
const sliders = document.querySelectorAll('.section_slider');

if(sliders.length) {
    const slider = tns({
        container: '.section_slider',
        mode: 'gallery',
        // items: 3,
        // slideBy: 'page',
        autoplay: true,
        // controlsPosition: 'bottom',
        arrowKeys: 'true',
        // autoplayTimeout: '3000',
        // autoHeight: true,
        mouseDrag: true,
        controls: false,
        // nav: false,
        autoplayButtonOutput: false,
        // autoWidth: true,
        // animateIn: 'slider-fadein',
        // animateOut: 'slider-fadeout',
        // animateNormal: 'slider-normal',
        speed: 1200,
    });
}

var watcher = new ScrollWatcher();
watcher.on("scrolling", function(evt) {
    if(evt.scrollY > Math.min(window.innerHeight, window.innerWidth) / 2) {
        document.body.classList.add('body--navigation-hidden-scrolled');
    } else {
        document.body.classList.remove('body--navigation-hidden-scrolled');
    }
});

// Lightbox

var elements = [...document.querySelectorAll('[data-behaviour="lightbox"]')];

elements.forEach( (elem) => {
    elem.addEventListener("click", (e) => {
        e.preventDefault();
        BigPicture({
            el: e.target,
            // ytSrc: 'z_PeaHVcohg',
            imgSrc: elem.href,
        })
    });
});

var elements = [...document.querySelectorAll('[data-behaviour="yt-lightbox"]')];

elements.forEach( (elem) => {
    elem.addEventListener("click", (e) => {
        e.preventDefault();
        BigPicture({
            el: e.target,
            ytSrc: elem.getAttribute('data-src'),
        })
    });
});

var elements = [...document.querySelectorAll('[data-behaviour="more-toggle"]')];

elements.forEach( (elem) => {
    elem.addEventListener("click", (e) => {
        e.preventDefault();
        const target = elem.getAttribute('data-target');
        document.getElementById(target).parentNode.classList.toggle('more_content--show')
    });
});

//Contacts

var elements = [...document.querySelectorAll('[data-behaviour="contact-toggle"]')];

elements.forEach((elem) => {
    elem.addEventListener("click", (e) => {
        // e.preventDefault();
        const contact_item = elem.closest('.contact_item');
        contact_item.classList.toggle('contact_item--active');
        const form = contact_item.querySelector('.contact_form');
        form.classList.remove('contact_form--sent')
    });
});

//Contact Form
const forms = document.querySelectorAll('[data-behaviour="contact-form"]');

forms.forEach( (elem) => {
    elem.addEventListener("submit", (e) => {
        e.preventDefault();
        elem.parentNode.parentNode.classList.add('contact_form--sent');
        const data = new FormData(elem);
        const action = elem.getAttribute('action');
        axios.post(action, data);
    })
});
